module.exports = __webpack_public_path__ + "img/scikit-learn.98344818.png";